
import { useState } from 'react';
import Logo from '../../assets/images/logo.svg';
import { Link } from 'react-router-dom';
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { HiOutlineEnvelope } from "react-icons/hi2";
import { HiOutlineKey } from "react-icons/hi2";
import { HiOutlineUser } from "react-icons/hi";
import "./signup.scss";
import WebService from '../../Services/WebService';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import { Controller, useForm } from "react-hook-form";
import { Container, Button, Col, Row, Table, Card } from "react-bootstrap";
import PhoneNumberInput from '../PhonePicker/PhoneNumberInput';



const Signup = () => {
    const {
        register,
        reset,
        watch,
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({ mode: "onChange" });
    const [password, setPassword] = useState("");
    const [SelectedCountryCode, setSelectedCountryCode] = useState("+91");
    const [type, setType] = useState('password');
    const [icon, setIcon] = useState<any>(BsEyeSlash);
    const [showLoader, setShowLoader] = useState<any>(false);
    const [error, setError] = useState<any>(false);
    const [loading, setLoading] = useState<any>(false);
    const [mobileno, setMobileNo] = useState('');
    const [passwordShow, setPasswordShow] = useState<any>(false);


    const history = useNavigate();
    const handleToggle = () => {
        if (type === 'password') {
            setIcon(BsEye);
            setType('text')
        } else {
            setIcon(BsEyeSlash)
            setType('password')
        }
    }

    const onSave = (data: any) => {
        var obj = {
            'name': data.name,
            'email': data.email,
            'mobile_no': data.mobile_no,
            'password': data.password,
            'mobile_country_code': SelectedCountryCode,
        };
        obj.name = data.name;
        setLoading(true);
        WebService.postAPI({
            action: `/signup`,
            body: data
        })
            .then((res: any) => {
                if (res) {
                    toast.success(res.message);
                    history("/login");
                }
                setLoading(false);
            })
            .catch((e) => {
                setError(true);
                setLoading(false);
            });
    };
    return (
        <>
            <div className="login-page">
                <div className="row justify-content-center min-vh-100 align-items-center mx-0">
                    <div className="col-lg-5 d-flex align-items-center justify-content-center">
                        <div className="w-100 login-card rounded-4">
                            <div className="px-lg-5 px-3 py-5 ">
                                <form onSubmit={handleSubmit(onSave)}>
                                    <div className="mb-3 text-center">
                                        <img src={Logo} width="142" height={85} alt="Logo" />
                                    </div>
                                    <div>

                                        <h1 className="text-black mb-4 font-bold text-center h2">Welcome to Zaislu Rinkiniai</h1>
                                        <div className="form-group">
                                            <div className="input-group">
                                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                                    <HiOutlineUser size={16} />
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control  border-start-0 ps-0"
                                                    autoComplete="off"
                                                    placeholder="Enter Name "
                                                    {...register("name", { required: true })}
                                                />

                                            </div>
                                            {errors.name && (
                                                <small className="text-danger fs-12">
                                                    Please enter name
                                                </small>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <div className="input-group  mt-3">
                                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                                    <HiOutlineEnvelope size={16} />
                                                </span>
                                                <input
                                                    type="email"
                                                    className="form-control  border-start-0 ps-0"
                                                    autoComplete="off"
                                                    placeholder="Enter email "
                                                    {...register("email", {
                                                        required: true,
                                                        pattern: /^\S+@\S+$/i,
                                                    })}
                                                />
                                            </div>
                                            {errors.email && (
                                                <small className="text-danger fs-12">
                                                    Please enter valid email
                                                </small>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <div className="input-group mt-3">
                                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                                    <HiOutlineKey size={16} />
                                                </span>
                                                <input
                                                    id="password"
                                                    autoComplete="off"
                                                    type={type}
                                                    className="form-control border-end-0 border-start-0 ps-0"
                                                    placeholder="Enter Password"
                                                    {...register("password", {
                                                        required: true,
                                                        minLength: {
                                                            value: 6,
                                                            message:
                                                                "Password must be at least 6 characters",
                                                        },
                                                    })}
                                                />
                                                <span className="input-group-text text-secondary bg-white border-start-0 cursor-pointer" onClick={handleToggle} >
                                                    {type == "password" ? <BsEye size={16} /> : <BsEyeSlash size={16} />
                                                    }
                                                </span>
                                            </div>
                                            {errors.password && (
                                                <small className="text-danger fs-12">
                                                    Please enter password
                                                </small>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <div className="input-group mt-3">
                                                <span className="input-group-text bg-white border-end-0 text-secondary">
                                                    <HiOutlineKey size={16} />
                                                </span>
                                                <input
                                                    id="confirm password"
                                                    type={type}
                                                    className="form-control border-end-0 border-start-0 ps-0"
                                                    placeholder="Confirm Password"
                                                    {...register("confirmPassword", {
                                                        required: "Confirm Password is required",
                                                        validate: (value) => {
                                                            console.log("Confirm Password Validation Triggered");
                                                            const { password } = watch();
                                                            console.log("Current Password:", password);
                                                            return value === password || "Passwords do not match";
                                                        },
                                                    })}
                                                />
                                                <span className="input-group-text text-secondary bg-white border-start-0 cursor-pointer" onClick={handleToggle} >
                                                    {type == "password" ? <BsEye size={16} /> : <BsEyeSlash size={16} />
                                                    }
                                                </span>
                                            </div>
                                            {errors.confirmPassword?.type === "required" && (
                                                <small className="text-danger">
                                                    Confirm password is required
                                                </small>
                                            )}
                                            {errors.confirmPassword?.type === "validate" && (
                                                <small className="text-danger">
                                                    Password is not matched
                                                </small>
                                            )}
                                        </div>
                                        <Col lg={12} className="mt-3">
                                            <div className="from-group w-100">
                                                <Controller
                                                    control={control}
                                                    name="mobile_no"
                                                    rules={{
                                                        required: true,
                                                    }}
                                                    render={({ field }) => (
                                                        <PhoneNumberInput
                                                            placeholder="Phone Number"
                                                            value={mobileno}
                                                            selected={SelectedCountryCode}
                                                            onChange={(e: any) => {
                                                                console.log("mfff", e)
                                                                field.onChange(e);
                                                                setMobileNo(e)
                                                            }}
                                                            onChangeCode={(e: any) => {
                                                                console.log("Phone Number Data: ", e);
                                                                setSelectedCountryCode(e.phone_code);
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <div className='mb-2'>
                                                {errors.mobile_no && (
                                                    <small className="text-danger">
                                                        Please enter mobile no.
                                                    </small>
                                                )}
                                            </div>


                                        </Col>
                                    </div>

                                    <div className="text-center mt-3 ">
                                        <button
                                            type="submit"
                                            className="btn btn-brand-1 w-100"
                                        >
                                            {" "}
                                            {error ? null : loading ? (
                                                <Spinner size="sm" className="me-2">
                                                    {" "}
                                                    Loading..{" "}
                                                </Spinner>
                                            ) : null}
                                            Sign up
                                        </button>
                                        <p className='text-black mt-3 mb-0'>Already have an account? <Link to="/login" className="text-brand" style={{ color: '#4633ff' }}> <b>Login</b></Link></p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default Signup;